export const ApplePayOrder = () => (
  <p className="mt-2 flex gap-x-2">
    <img src="https://m.media-amazon.com/images/G/01/zappos/ui/applepay-outlined._CB1736808458_.svg" width="24" alt="This is an Apple Pay order" />
    <p className="body-s">Purchased with Apple Pay</p>
  </p>
);
